module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Green_HK.71d11adc.png";